import React from "react";

function Filter(){
    return(
        <div className="d-flex flex-column bg-grey vh-100 my-2 p-4">
            <div className="p-0">
                <h2>Filters</h2>
                <div>
                    <form>
                        <div className="my-3">
                            <div className="accordion accordion-flush" id="accordionFlushExample1">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingTwo">
                                    <button className="accordion-button collapsed fs-5 px-1 bg-grey" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseStatus" aria-expanded="false" aria-controls="flush-collapseTwo">
                                        Status
                                    </button>
                                    </h2>
                                    <div id="flush-collapseStatus" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body p-0">
                                            <div className="py-4">
                                                <div className="form-check checkbox-lg">
                                                    <input type="checkbox" className="form-check-input"></input>
                                                    <label className="fs-5 ms-3">Buy Now</label>
                                                </div>
                                                <div className="form-check checkbox-lg">
                                                    <input type="checkbox" className="form-check-input"></input>
                                                    <label className="fs-5 ms-3">On Auction</label>
                                                </div>
                                                <div className="form-check checkbox-lg">
                                                    <input type="checkbox" className="form-check-input"></input>
                                                    <label className="fs-5 ms-3">New</label>
                                                </div>
                                                <div className="form-check checkbox-lg">
                                                    <input type="checkbox" className="form-check-input"></input>
                                                    <label className="fs-5 ms-3">Has offer</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="my-3">
                            <div className="accordion accordion-flush" id="accordionFlushExample1">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingTwo">
                                    <button className="accordion-button collapsed fs-5 px-1" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapsePrice" aria-expanded="false" aria-controls="flush-collapseTwo">
                                        Price
                                    </button>
                                    </h2>
                                    <div id="flush-collapsePrice" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body p-0">
                                            <div className="py-4">
                                                <select className="form-select d-block mb-2" aria-label="Default select example">
                                                    <option selected>USD</option>
                                                    <option value="1">ETH</option>
                                                    <option value="2">SOL</option>
                                                </select>
                                                <input type="text" placeholder="Min" className="form-control w-25 d-inline-block"></input>
                                                <label className="fs-5 fw-bold mx-1">to</label>
                                                <input type="text" placeholder="Max" className="form-control w-25 d-inline-block mx-1"></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="my-3">
                            <div className="accordion accordion-flush" id="accordionFlushExample2">
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="flush-headingTwo">
                                    <button className="accordion-button collapsed fs-5 px-1" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseQuantity" aria-expanded="false" aria-controls="flush-collapseTwo">
                                        Quantity
                                    </button>
                                    </h2>
                                    <div id="flush-collapseQuantity" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample2">
                                        <div className="accordion-body p-0">
                                            <ul className="d-flex list-group list-group-flush">
                                                <li className="list-group-item">
                                                    <div className="form-check">
                                                        <label className="form-check-label fs-5 ms-4">All items</label>
                                                        <input type="radio" className="form-check-input"></input>
                                                    </div>
                                                    <div className="form-check">
                                                        <label className="form-check-label fs-5 ms-4">Single item</label>
                                                        <input type="radio" className="form-check-input"></input>
                                                    </div>
                                                    <div className="form-check">
                                                        <label className="form-check-label fs-5 ms-4">Bundles</label>
                                                        <input type="radio" className="form-check-input"></input>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Filter;